import React from "react";

export default function Live() {
  return (
    <>
      <section id="live" className="details">
        <div className="container">
          <div className="section-title">
            <h2>Live</h2>
            <p>IO Logopedista - Live "Frasi per riparare l'alleanza"</p>
          </div>

          <div className="row content">
            <div className="col-md-8 pt-4 order-2 order-md-1">
              <p>
               Questo è uno spazio di trasformazione delle tue comunicazioni professionali. 
               Ci incontreremo online per ragionare su una frase che ti ha messo in difficoltà pronunciata da un paziente, caregiver, collega, docente: durante il live sarà analizzata e trasformata in risposta riparativa, a tutela dell'alleanza terapeutica.
              </p>
              <p>
               Al termine dell'incontro verrà rilasciato un PDF con l'analisi delle situazioni e le proposte suggerite.
              </p>
              <p>
               Il valore dell’incontro è il ragionamento che ti permetterà di leggere le dinamiche e costruire risposte riutilizzabili.
              </p>
               
              <ul>
                <li>
                  <strong>Live Zoom per massimo 20 logopedisti</strong>
                </li>
              </ul>

              <p>Quota:</p>
              <ul>
                <li>
                  &euro; 19 corsisti "IO logopedista Formazione per il Saper Essere"
                </li>
                <li>
                  &euro; 30 esterni
                </li>
              </ul>
                

                <section id="pricing" className="pricing pt-4 pb-4">
                <div className="row content">
                  <div className="col-md-6 mt-4 mt-md-0">
                    <div className="box featured">
                      <h3>Dove?</h3>
                      <div>
                        <strong>Online</strong>
                        <br />
                        piattaforma Zoom
                      </div>
                      {/* <div className="btn-wrap">
                                      <a className="cta-btn" href="https://shorturl.at/cAEHJ" target="_blank" rel="noreferrer">Programma Roma aprile 2024</a>                   
                                  </div> */}
                    </div>
                  </div>

                  <div className="col-md-6 mt-4 mt-md-0">
                    <div className="box featured">
                      <h3>Come?</h3>
                      <div>
                        Scrivi a:
                        <br />
                        <a href={`mailto:${process.env.REACT_APP_EMAIL}`}>
                          <strong>{process.env.REACT_APP_EMAIL}</strong>
                        </a>
                      </div>
                      {/* <div className="btn-wrap">
                                      <a className="cta-btn" href="https://shorturl.at/cAEHJ" target="_blank" rel="noreferrer">Programma Roma aprile 2024</a>                           
                                  </div> */}
                    </div>
                  </div>
                </div>
              </section>
              
             
            </div>
            <div className="col-md-4 order-1 order-md-2">
              <img
                src="assets/img/site/1/live.jpeg"
                className="img-fluid"
                alt=""
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
